export default defineNuxtPlugin(() => {
  const { $sitewideConfig } = useNuxtApp()
  const { isIntegrationEnabled } = useUtils()
  if (!isIntegrationEnabled('googlePlaces')) return

  const apiKey = $sitewideConfig.config.googlePlacesKey

  const { setLocation } = useLocation()

  // This is a modified version of the Google Maps JavaScript API loader, the original was an arrow IIFE but eslint and prettier wouldn't ignore it.
  /* eslint-disable */
  // prettier-ignore
  // @ts-ignore
  !function(g){var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))}({ key: apiKey, v: "weekly" })
  /* eslint-enable */

  async function setLocationByZipcode(zipcode: string) {
    const { Geocoder } = await getGoogleMapsGeocodingLibrary()

    const geocoder = new Geocoder()

    // Get the first result, if no results are found, the geocode function throws an error
    const {
      results: [result],
    } = await geocoder.geocode({
      componentRestrictions: {
        postalCode: zipcode,
      },
    })

    const location = result.address_components.reduce<UserLocation>(
      (acc, addressComponent) => {
        // The address_components array is a list of address components from most specific to least specific.
        addressComponent.types.forEach((type) => {
          switch (type) {
            case 'locality': //indicates an incorporated city or town political entity.
            case 'sublocality': // indicates a first-order civil entity below a locality.
            case 'sublocality_level_1': // Each sublocality level is a civil entity. Larger numbers indicate a smaller geographic area.
            case 'neighborhood': // indicates a named neighborhood
            case 'administrative_area_level_3': // indicates a third-order civil entity below the country level
              acc.city = addressComponent.long_name
              break

            case 'administrative_area_level_1': // indicates a first-order civil entity below the country level. Within the United States, these administrative levels are states. Not all nations exhibit these administrative levels.
            case 'administrative_area_level_2': // indicates a second-order civil entity below the country level. Within the United States, these administrative levels are counties. Not all nations exhibit these administrative levels.
              acc.region = addressComponent.short_name
              acc.regionName = addressComponent.long_name
              break

            case 'postal_code': // indicates a postal code as used to address postal mail within the country.
              acc.zipcode = addressComponent.short_name
              break

            case 'country': // indicates the national political entity, and is typically the highest order type returned by the Geocoder.
              acc.country = addressComponent.long_name
              acc.countryCode = addressComponent.short_name
              break
          }
        })

        return acc
      },
      {
        city: '',
        country: '',
        countryCode: '',
        latitude: result.geometry.location.lat(),
        longitude: result.geometry.location.lng(),
        region: '',
        regionName: '',
        zipcode: '',
      }
    )

    // Store the location that we geocoded above
    setLocation(location)

    return location
  }

  async function getGoogleMapsCoreLibrary() {
    return (await window.google.maps.importLibrary('core')) as google.maps.CoreLibrary
  }

  async function getGoogleMapsGeocodingLibrary() {
    return (await window.google.maps.importLibrary('geocoding')) as google.maps.GeocodingLibrary
  }

  async function getGoogleMapsLibrary() {
    return (await window.google.maps.importLibrary('maps')) as google.maps.MapsLibrary
  }

  async function getGoogleMapsMarkerLibrary() {
    return (await window.google.maps.importLibrary('marker')) as google.maps.MarkerLibrary
  }

  async function getGoogleMapsPlacesLibrary() {
    return (await window.google.maps.importLibrary('places')) as google.maps.PlacesLibrary
  }

  return {
    provide: {
      googlePlaces: {
        setLocationByZipcode,
        getGoogleMapsCoreLibrary,
        getGoogleMapsGeocodingLibrary,
        getGoogleMapsLibrary,
        getGoogleMapsMarkerLibrary,
        getGoogleMapsPlacesLibrary,
      },
    },
  }
})
